module.exports = __webpack_public_path__ + "cr.svg?241eea715bd6ab7a8ab41ec1edb22c72";